<h3 class="panel-title">Reset your password</h3>

<div class="margin-top light-control-host">
  @if (!resetSubmitted) {
    <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
      <div class="flex-center-column">
        <div>If you've forgotten your password, we'll email you a link that you can use to reset it.</div>
        <div class="flex-center-row full-width padding-top field-issue-container">
          <input
            id="email"
            class="arpio-input"
            type="text"
            placeholder="Email"
            formControlName="email"
            autocomplete="username"
          />
          <arp-field-issue [message]="errorMessage"></arp-field-issue>
        </div>
        <button busy-button [busy]="resetting" class="arpio-button" type="submit" [disabled]="!submitButtonEnabled">
          Reset Password
        </button>
      </div>
    </form>
  } @else {
    If that email address is in our records, we've sent you a link to reset your password. Check your inbox for the next
    step.
  }
</div>
